import React from 'react'
import PropTypes from 'prop-types'

import './styles.css'

const LoadingSpinnerIcon = ({ width, height, fill, backgroundFill, }) => {
  const styles = {
    border: `4px solid ${backgroundFill}`,
    borderTopColor: fill,
    width,
    height,
  }
  return <div style={styles} className="loading-spinner" />
}

LoadingSpinnerIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
  backgroundFill: PropTypes.string,
}

LoadingSpinnerIcon.defaultProps = {
  width: '50px',
  height: '50px',
  fill: 'white',
  backgroundFill: 'gray',
}

export default LoadingSpinnerIcon



// WEBPACK FOOTER //
// ./src/components/icons/LoadingSpinner/index.js